import React, { Component } from "react";
import {
    Label,
    Row,
    Col,
    Input,
    Button,
    InputGroup,
    InputGroupAddon
} from "reactstrap";
import TYSelect from "../TYSelect";
import Variables from "../../Utils/Variables";
import Registry from "../../Utils/Registry";
import {NotificationManager} from "react-notifications";

class ConfigurationFormWeb extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                social_reason: this.props.business.name,
                siret: this.props.business.siren,
                type_activity: this.props.business.type_activity,
                address: this.props.business.address,
                zip_code: this.props.business.zip_code,
                country: this.props.business.country,
                city: this.props.business.city,
                fleet: {
                    light_fleet: 0,
                    utility_fleet: 0,
                    heavy_fleet: 0,
                    other_fleet: 0
                }
            }
        };

        this.api = Registry.registered("api");
    }

    inputChanged = (e, input_key) => {
        if(this.state.data.hasOwnProperty(input_key) && typeof e !== "undefined"){
            let nState = this.state;

            nState.data[input_key] = (typeof e === "string" ? e : e.target.value);
            // nState.errors[input_key] = false;
            this.setState(nState);
        }
    };

    changeNbFleet = (e, input_key, increase = true) => {
        let nState = this.state.data;
        if (e.target.value === undefined) {
            if(this.state.data.fleet.hasOwnProperty(input_key) && typeof e !== "undefined"){
                if (increase) {
                    nState.fleet[input_key] += 1;
                } else {
                    if (nState.fleet[input_key] !== 0) {
                        nState.fleet[input_key] -= 1;
                    }
                }
            }
        } else {
            let int = parseInt(e.target.value);
            let val = isNaN(int) ? 0 : int;
            nState.fleet[input_key] = val;
        }
        this.setState(nState);
    };

    sendInfo = () => {
        if (this.state.data.social_reason === "" || this.state.data.siret === "" || this.state.data.type_activity === "" || this.state.data.address === '' || this.state.data.zip_code === '' || this.state.data.city === '') {
            NotificationManager.error("Tous les champs sont requis");
        } else {
            this.api.put("/business/" + this.props.business.id + "/onboard_request", {
                social_reason: this.state.data.social_reason,
                siret: this.state.data.siret,
                type_activity: this.state.data.type_activity,
                address: this.state.data.address,
                city: this.state.data.city,
                zip_code: this.state.data.zip_code,
                country: this.state.data.country,
                fleet: JSON.stringify(this.state.data.fleet)
            })
                .then(res => {
                    NotificationManager.success("Demande envoyée");
                    this.props.loadBusiness();
                    this.props.toggle();
                })
                .catch(err => {
                    NotificationManager.error("Une erreur est survenue");
                });
        }
    };


    render() {
        return (
            <div>
                <Row className="marg-b-20">
                    <Col md="6">
                        <Label>Raison social</Label>
                        <Input
                            type="text"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "social_reason"))}
                            value={this.state.data.social_reason}
                        />
                    </Col>
                    <Col md="6">
                        <Label>Code SIRET</Label>
                        <Input
                            name="siret"
                            type="text"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "siret"))}
                            value={this.state.data.siret}
                        />
                    </Col>
                </Row>
                <Row className="marg-b-20">
                    <Col md="12">
                        <Label>Secteur d'activit&eacute;</Label>
                        <TYSelect
                            items={Variables.enterprise_activities}
                            selected={this.state.data.type_activity}
                            otherActive={true}
                            itemClicked={(e) => this.inputChanged(e, "type_activity")}
                            onOtherValueChanged={(e) => this.inputChanged(e, "type_activity")}
                        />
                    </Col>
                </Row>
                <Row className="marg-b-20">
                    <Col md="12">
                        <Label>Adresse</Label>
                        <Input
                            name="address"
                            placeholder="Adresse"
                            type="text"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "address"))}
                            value={this.state.data.address}
                        />
                    </Col>
                </Row>
                <Row className="marg-b-20">
                    <Col md="4">
                        <Input
                            name="city"
                            placeholder="Ville"
                            type="text"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "city"))}
                            value={this.state.data.city}
                        />
                    </Col>
                    <Col md="4">
                        <Input
                            name="zip_code"
                            placeholder="Code postal"
                            type="text"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "zip_code"))}
                            value={this.state.data.zip_code}
                        />
                    </Col>
                    <Col md="4">
                        <Input
                            name="country"
                            placeholder="Pays"
                            type="select"
                            rows="5"
                            onChange={(e => this.inputChanged(e, "country"))}
                            value={this.state.data.country}
                        >
                            <option value="FR">France</option>
                            <option value="BE">Belgique</option>
                            <option value="LU">Luxembourg</option>
                        </Input>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Label>Flotte</Label>
                        <div className="ty-block configuration-form">
                            <Row className="marg-b-20">
                                <Col md="4" className="text-center">
                                    <InputGroup>
                                        <InputGroupAddon
                                            className={"input-cars-minus ty-font icon-less" + (this.state.data.fleet.light_fleet > 0 ? " active" : "")}
                                            onClick={(e) => {this.changeNbFleet(e, "light_fleet", false)}}
                                        >
                                        </InputGroupAddon>
                                        <Input
                                            className="input-cars"
                                            value={this.state.data.fleet.light_fleet}
                                            onChange={(e) => this.changeNbFleet(e, "light_fleet")}
                                        />
                                        <InputGroupAddon
                                            className="input-cars-plus ty-font icon icon-plus"
                                            onClick={(e) => {this.changeNbFleet(e, "light_fleet", true)}}
                                        >
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col md="6" className="pad-t-10">
                                    V&eacute;hicules l&eacute;gers
                                </Col>
                            </Row>
                            <Row className="marg-b-20">
                                <Col md="4" className="text-center">
                                    <InputGroup>
                                        <InputGroupAddon
                                            className={"input-cars-minus ty-font icon-less" + (this.state.data.fleet.utility_fleet > 0 ? " active" : "")}
                                            onClick={(e) => {this.changeNbFleet(e, "utility_fleet", false)}}
                                        >
                                        </InputGroupAddon>
                                        <Input
                                            className="input-cars"
                                            value={this.state.data.fleet.utility_fleet}
                                            onChange={(e) => this.changeNbFleet(e, "utility_fleet")}
                                        />
                                        <InputGroupAddon
                                            className="input-cars-plus ty-font icon icon-plus"
                                            onClick={(e) => {this.changeNbFleet(e, "utility_fleet", true)}}
                                        >
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col md="6" className="pad-t-10">
                                    V&eacute;hicules utilitaires
                                </Col>
                            </Row>
                            <Row className="marg-b-20">
                                <Col md="4" className="text-center">
                                    <InputGroup>
                                        <InputGroupAddon
                                            className={"input-cars-minus ty-font icon-less" + (this.state.data.fleet.heavy_fleet > 0 ? " active" : "")}
                                            onClick={(e) => {this.changeNbFleet(e, "heavy_fleet", false)}}
                                        >
                                        </InputGroupAddon>
                                        <Input
                                            className="input-cars"
                                            value={this.state.data.fleet.heavy_fleet}
                                            onChange={(e) => this.changeNbFleet(e, "heavy_fleet")} />
                                        <InputGroupAddon
                                            className="input-cars-plus ty-font icon icon-plus"
                                            onClick={(e) => {this.changeNbFleet(e, "heavy_fleet", true)}}
                                        >
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col md="6" className="pad-t-10">
                                    V&eacute;hicules poids lourds
                                </Col>
                            </Row>
                            <Row className="marg-b-20">
                                <Col md="4" className="text-center">
                                    <InputGroup>
                                        <InputGroupAddon
                                            className={"input-cars-minus ty-font icon-less" + (this.state.data.fleet.other_fleet > 0 ? " active" : "")}
                                            onClick={(e) => {this.changeNbFleet(e, "other_fleet", false)}}
                                        >
                                        </InputGroupAddon>
                                        <Input
                                            className="input-cars"
                                            value={this.state.data.fleet.other_fleet}
                                            onChange={(e) => this.changeNbFleet(e, "other_fleet")} />
                                        <InputGroupAddon
                                            className="input-cars-plus ty-font icon icon-plus"
                                            onClick={(e) => {this.changeNbFleet(e, "other_fleet", true)}}
                                        >
                                        </InputGroupAddon>
                                    </InputGroup>
                                </Col>
                                <Col md="6" className="pad-t-10">
                                    Autres <span className="font-other-car">(Groupe &eacute;lectrog&egrave;ne, ...)</span>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                </Row>
                <div className="center pad-b-20 pad-t-20">
                    <Button className="text-uppercase" size="" color="primary" onClick={this.sendInfo}>Envoyer</Button>
                </div>
            </div>
        );
    }
}

ConfigurationFormWeb.defaultProps = {
    user: null,
    toggle: () => {},
    loadBusiness: () => {}
};

export default ConfigurationFormWeb;



// WEBPACK FOOTER //
// ./src/components/Account/ConfigurationFormWeb.js